/**
 * Created by Ning Jiang on 10/18/2018.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {
    IScatterAttentionConfig,
    ScatterAttentionController
} from "@nolimitcity/slot-game/bin/game/reelstoppresentation/scatterattention/ScatterAttentionController";
import {Timeline, TimelineLite} from "gsap";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";

export class TombstoneScatterAttentionController extends ScatterAttentionController {

    private _bonusPositions:number[];
    private _hasBetWayWin:boolean;
    private _isFreespinMode:boolean;
    private _isLooping:boolean = false;

    constructor(index:number, config:IScatterAttentionConfig) {
        super(index, config);
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        super.parseFeatureGameData(data);
        this._isFreespinMode = data.mode === GameMode.FREESPIN || data.mode === TombstoneGameMode.SUPER_FREESPIN;
        this._bonusPositions = data.bonusPositions;
        this._hasBetWayWin = data.betWins != null && data.betWins.length > 0;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._isFreespinMode) {
            if((data.reelId === 0 && this._scatterPositions[0] > -1) || (data.reelId === 4 && this._scatterPositions[4] > -1)) {
                this.playSymbolAttentionAnimation(data.reelId, this._scatterPositions[data.reelId], false);
                SlotGame.sound.playEffect(TombstoneSoundConfig.instance.SCATTER_LANDING_FREESPIN);
            }
            this.dispatchCompleteEvent(data.reelId);
            return;
        }
        if(this._isLooping) {
            if(data.reelId === 2 && this._scatterPositions[2] < 0) {
                this._isLooping = false;
            }
            if(data.reelId === 3 && this._scatterPositions[3] < 0) {
                this._isLooping = false;
            }
            if(data.reelId === 4) {
                this._isLooping = false;
            }
        }
        super.onReelBounce(data);
    }

    protected playAttentionAnimation(data:IReelStoppedData):void {
        this.playSymbolAttentionAnimation(data.reelId, this._scatterPositions[data.reelId], true);
        SlotGame.sound.playEffect((<any>TombstoneSoundConfig.instance)[`SCATTER_LANDING_${data.reelId}`]);
        this.dispatchCompleteEvent(data.reelId);
    }

    protected playWinAttentionAnimation(data:IReelStoppedData):void {
        SlotGame.sound.playEffect(TombstoneSoundConfig.instance.SCATTER_LANDING_WIN);

        const bonusOnAttention:boolean = this._bonusPositions[0] > -1;
        if((!this._hasBetWayWin && !bonusOnAttention) && (data.quickStop || data.fastSpin)) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        const timeline:TimelineLite = new TimelineLite({paused : true});
        for(let i:number = 1; i < 4; i++) {
            timeline.add(() => this.playSymbolAttentionAnimation(i, this._scatterPositions[i], bonusOnAttention), 0);
        }
        timeline.add(() => this.dispatchCompleteEvent(data.reelId));

        timeline.play();
    }

    private playSymbolAttentionAnimation(reelId:number, symbolId:number, loop:boolean):Timeline {
        this._isLooping = loop;
        const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(scatter == null) {
            debugger;
            throw new Error(`TombstoneScatterAttentionController.playScatterAttentionAnimation(): Cannot find symbol at reelId = ${reelId}, symbolId = ${symbolId}.`);
        }

        scatter.parent.addChild(scatter);
        return scatter.changeState({
            state : TombstoneGameConfig.instance.SYMBOL_STATES.attention,
            replay : true,
            fadeInDuration : 0.5,
            onCompleteCallback : () => {
                if(this._isLooping) {
                    this.playSymbolAttentionAnimation(reelId, symbolId, true);
                }
            }
        })!;
    }
}